import { NON_BREAKING_SPACE } from 'utils/constants/common';
import { formatDate } from 'utils/date';

import NumberFormatter from 'bloko/common/numberFormatter';

import { getSelectedSegmentsFromDTO } from 'components/Admin/PromoCodes/utils/mappingData';

import { PromoCodeBound } from 'store/models/promoCodes';

export const formatBound = (bound?: PromoCodeBound | null | undefined): string => {
    if (!bound) {
        return 'Все';
    }

    const formattedSegments = bound.employerMarketSegments
        ? [...getSelectedSegmentsFromDTO(bound.employerMarketSegments)]
        : [];

    const segments = formattedSegments.join(', ') || '';
    const ids = bound.employerIds?.join(', ') || '';

    return [segments, ids].filter(Boolean).join(', ') || 'Все';
};

export const formatPeriod = (startDate: string | null, endDate: string | null): string => {
    if (!endDate) {
        return 'Без ограничений';
    }
    const start = startDate ? formatDate(startDate, 'dd.MM.yy') : '';
    const end = formatDate(endDate, 'dd.MM.yy');
    return start ? `${start} – ${end}` : end;
};

export const formatRemainingActivations = (limit: number | null, count: number): string => {
    if (limit === null) {
        return 'Без ограничений';
    }
    const remaining = Math.max(0, limit - count);
    return NumberFormatter.format(String(remaining), { groupSeparator: NON_BREAKING_SPACE });
};
